module.exports = __webpack_public_path__ + "img/10.d6e1fcf8.jpg";